/* eslint-disable react/prop-types */
import React from 'react';
import {
  ProductPod,
  ProductRating, ProductBadge,
  ProductImage, PodSection
} from '@thd-olt-component-react/product-pod';
import { Price } from '@thd-olt-component-react/price';
import { ProductHeader } from '@thd-olt-component-react/product-details';
import { extend } from '@thd-nucleus/data-sources';

const CustomProductPodHomepage = ({ itemId, storeId, idx }) => {
  const analyticsData = {
    parent: 'product-shelf',
    position: idx
  };

  // TODO: get product pod folks to add sui-text-primary at the root so we dont
  // need to smuggle it in the padding prop
  return (
    <ProductPod
      itemId={itemId}
      analyticsData={analyticsData}
      storeId={storeId}
      padding="sui-text-primary sui-p-2"
      borderRadius="!sui-rounded-[8px]"
      render={(pod) => (
        <>
          <ProductImage
            itemId={pod.itemId}
            showSecondaryImage={pod.showSecondaryImage}
            onClick={() => {}}
            enableRoundedProductImages
          />
          <PodSection columnAlign alignTop noPadding gap="sui-gap-0">
            <ProductHeader
              brand="inline"
              itemId={pod.itemId}
              titleMaxLine={2}
              brandMaxLine={1}
              disableShopThisCollection
            />
            <ProductRating itemId={pod.itemId} onlyReviewCount />
            <div className="sui-mt-4">
              <Price
                itemId={pod.itemId}
                large={false}
                storeId={pod.storeId}
                displayEachUom={false}
                stackWasPrice
                onSavingsCenterToggle={pod.onSavingsCenterToggle}
                hideForProductTypes={['HDQC']}
                type="simple"
                hidePromotions
                hideLimitPerOrder
                hideRebates
              />
            </div>
          </PodSection>

        </>
      )}
    />
  );
};

CustomProductPodHomepage.dataModel = extend(
  Price,
  ProductBadge,
  ProductHeader,
  ProductImage,
  ProductPod,
  ProductRating
);

CustomProductPodHomepage.displayName = 'CustomProductPodHomepage';

export { CustomProductPodHomepage };
